<div class="windows98-message-box">
    <div class="title-bar">
        <div class="title">Loading...</div>
        <div class="close-button">X</div>
    </div>
    <div class="content">
        <p>{{ message }}{{ dots }}</p>
        <div class="progress-bar-container">
            <div class="progress-bar"></div>
        </div>
    </div>
</div>
